import React, { useContext } from 'react';
import { Button, KIND, SIZE } from 'baseui/button';
import { useStyletron } from 'baseui';

import { DataList, Loader, ModalContext } from 'commons-ui';
import Accordian from 'commons-ui/src/components/keyValueView/Accordian';
import { LIST_ENTITY_NAMES } from 'constant';
import { columnConfigs } from './listConfig';
import useForm60Details from './useForm60Details';
import SubmitForm60 from './submitForm60';

const Form60Details: React.FC<{}> = () => {
	const {
		form60IsCollapsed,
		setForm60IsCollapsed,
		showLoader,
		handleDatalistFetchData,
		turnForceUpdateOn,
		turnForceUpdateOff,
		forceUpdate,
		submitForm60Details,
		dataFetchComplete
	} = useForm60Details();
	const [css] = useStyletron();
	const { setModalConfig } = useContext(ModalContext);
	const handleForm60 = async (event: any) => {
		event.preventDefault();
		event.stopPropagation();
		setModalConfig({
			isOpen: true,
			header: 'Submit Form60 Details',
			content: <SubmitForm60 turnForceUpdateOn={turnForceUpdateOn} submitForm60Details={submitForm60Details} />
		});
	};
	const form60Label = (
		<div className={css({ display: 'flex', justifyContent: 'space-between', minWidth: '500px' })}>
			<div className={css({ fontWeight: 'bold', padding: '12px 0px' })}>Form60 Details</div>
			<div title='Upload Form60' className={css({ padding: '8px 0px' })}>
				<Button kind={KIND.primary} size={SIZE.mini} onClick={handleForm60}>
					Upload Form60
				</Button>
			</div>
		</div>
	);

	return (
		<>
			{showLoader && <Loader />}
			<Accordian
				label={form60Label}
				panelKey='unnamedPanel'
				isCollapsed={form60IsCollapsed}
				setIsCollapsed={setForm60IsCollapsed}>
				{dataFetchComplete && (
					<DataList
						fetchData={handleDatalistFetchData}
						columnConfigs={columnConfigs}
						hideActions
						entity={LIST_ENTITY_NAMES.FORM60_DETAILS}
						filterable={false}
						searchable={false}
						globalForceUpdate={forceUpdate}
						turnGlobalForceUpdateOff={turnForceUpdateOff}
						height='150px'
						disablePagination
						showFooterMessage={false}
					/>
				)}
			</Accordian>
		</>
	);
};

export default Form60Details;
